/**
 * Certificate Table Columns Configuration
 * Defines columns for the DataTable component
 */

import { createColumnHelper } from '@tanstack/react-table';
import { StatusBadge } from '@/components/Common/StatusBadge';
import type { CertificateListItem } from '@/types';
import { formatDate } from '@/utils';
import styles from './certificateColumns.module.css';

const columnHelper = createColumnHelper<CertificateListItem>();

/**
 * Certificate Columns for DataTable
 */
export const certificateColumns = [
  columnHelper.accessor('id', {
    header: 'ID',
    cell: (info) => <span className={styles.id}>{info.getValue()}</span>,
    size: 80,
  }),

  columnHelper.accessor('alias', {
    header: 'Alias',
    cell: (info) => <span className={styles.alias}>{info.getValue()}</span>,
    size: 200,
  }),

  columnHelper.accessor('ref', {
    header: 'Referência',
    cell: (info) => (
      <span className={styles.reference} title={info.getValue()}>
        {info.getValue().substring(0, 20)}...
      </span>
    ),
    size: 150,
  }),

  columnHelper.accessor('organizationId', {
    header: 'Org ID',
    cell: (info) => <span className={styles.orgId}>{info.getValue()}</span>,
    size: 80,
  }),

  columnHelper.accessor('expiresAt', {
    header: 'Data de Expiração',
    cell: (info) => {
      const value = info.getValue();
      const date = value ? formatDate(value) : '-';
      return <span className={styles.date}>{date}</span>;
    },
    size: 150,
  }),

  columnHelper.accessor('createdAt', {
    header: 'Criado em',
    cell: (info) => {
      const value = info.getValue();
      const date = value ? formatDate(value) : '-';
      return <span className={styles.date}>{date}</span>;
    },
    size: 150,
  }),

  columnHelper.accessor('updatedAt', {
    header: 'Atualizado em',
    cell: (info) => {
      const value = info.getValue();
      const date = value ? formatDate(value) : '-';
      return <span className={styles.date}>{date}</span>;
    },
    size: 150,
  }),

  columnHelper.accessor('status', {
    header: 'Status',
    cell: (info) => (
      <StatusBadge 
        status={info.getValue() as 'valid' | 'expiring' | 'expired'}
        type="certificate"
      />
    ),
    size: 120,
  }),
];
